// =============================================================================
// Xero deep links (T-488d).
//
// Every pushed transaction stores the Xero GUID it came back with
// (ap_invoices.xero_bill_id). This turns that id into a one-click link to the
// actual document, so "is it in Xero and is it right" is answered by looking
// rather than by searching Xero for a supplier and a number.
//
// The organisationlogin/redirecturl wrapper matters: without it, someone signed
// in to more than one Xero org lands in whichever org Xero saw last, which for a
// bookkeeper working across clients is most of the time.
// =============================================================================

const XERO_SHORTCODE = (import.meta as any).env?.VITE_XERO_SHORTCODE ?? "!QHgP0";

export function xeroDeepLink(path: string): string {
  return `https://go.xero.com/organisationlogin/default.aspx`
    + `?shortcode=${XERO_SHORTCODE}`
    + `&redirecturl=${encodeURIComponent(path)}`;
}

// A pushed AP record is either an ACCPAY bill or a SPEND bank transaction, and
// they live at different addresses in Xero. Returns null when there is no id —
// callers should show nothing rather than a link that goes to a blank form.
export function xeroTransactionUrl(
  entryType: string | null | undefined,
  xeroId: string | null | undefined,
): string | null {
  const id = String(xeroId ?? "").trim();
  if (!id) return null;
  return entryType === "spend_money"
    ? xeroDeepLink(`/Bank/ViewTransaction.aspx?bankTransactionID=${id}`)
    : xeroDeepLink(`/AccountsPayable/View.aspx?InvoiceID=${id}`);
}
